(function($) {
	
	if ( $('.section-hero .description').length ) {
		var desc = $('.section-hero .description').html();
		$('.section-hero .mobile-description').html( desc );
	}

	$('.section-hero .down').on('click', function(event) {
		event.preventDefault();
		
		var headerHeight = $('.site-header .header-content').height();

		var $hero = $(this).closest('.section-hero');
		var heroTop = $hero.offset().top;
		var heroHeight = $hero.height();

		var contentOffset = heroTop + heroHeight - headerHeight;

		$('html, body').stop().animate({scrollTop: contentOffset}, 500, 'swing');
	});

})(jQuery);